import { InboxIcon } from 'lucide-react';

interface EmptyStateProps {
  message: string;
  icon?: React.ReactNode;
  className?: string;
}

export function EmptyState({ message, icon, className = '' }: EmptyStateProps) {
  return (
    <div className={`flex flex-col items-center justify-center py-12 text-center ${className}`}>
      <div className="mb-3 text-muted-foreground/50">
        {icon || <InboxIcon className="h-10 w-10" />}
      </div>
      <p className="text-sm text-muted-foreground">{message}</p>
    </div>
  );
}
